import { Injectable } from '@angular/core';

import { mergeMap, map, catchError, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';

/* NgRx */
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ClasePerdidaService } from '../clase-perdida.service';
import { ClasePerdidaApiActions, ClasePerdidaPageActions } from './actions';


@Injectable()
export class ClasePerdidaEffects {

  constructor(
    private actions$: Actions,
    private service: ClasePerdidaService
  ) { }

  loadUnidadMaterias$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClasePerdidaPageActions.loadUnidadMaterias),
      mergeMap(action => this.service.getUnidadMaterias(action.idUnidad).pipe(
        map(materias => ClasePerdidaApiActions.loadUnidadMateriasSuccess({ materias })),
        catchError(error => of(ClasePerdidaApiActions.loadUnidadMateriasFailure({ error })))
      ))
    );
  });

  loadPerdidas$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClasePerdidaPageActions.loadClasePerdidas),
      mergeMap(action => this.service.getClasesPerdidas(action.idUnidad).pipe(
        map(clasePerdidas => ClasePerdidaApiActions.loadClasePerdidasSuccess({ clasePerdidas })),
        catchError(error => of(ClasePerdidaApiActions.loadClasePerdidasFailure({ error }))),
      ))
    );
  });

  deletePerdida$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClasePerdidaPageActions.deleteClasePerdida),
      concatMap(action => this.service.updateClasePerdida(action.clasePerdida).pipe(
        map(clasePerdida => ClasePerdidaApiActions.deleteClasePerdidaSuccess({ clasePerdida })),
        catchError(error => of(ClasePerdidaApiActions.deleteClasePerdidaFailure({ error }))),
      ))
    );
  });

  updatePerdida$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClasePerdidaPageActions.updateClasePerdida),
      concatMap(action => this.service.updateClasePerdida(action.clasePerdida).pipe(
        map(clasePerdida => ClasePerdidaApiActions.updateClasePerdidaSuccess({ clasePerdida })),
        catchError(error => of(ClasePerdidaApiActions.updateClasePerdidaFailure({ error })))
      ))
    );
  });

  createClasePerdida$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClasePerdidaPageActions.createClasePerdida),
      concatMap(action => this.service.createClasePerdida(action.clasePerdida).pipe(
          map(clasePerdida => ClasePerdidaApiActions.createClasePerdidaSuccess({ clasePerdida })),
          catchError(error => of(ClasePerdidaApiActions.createClasePerdidaFailure({ error })))
        )
      )
    );
  });
}
